import { render, staticRenderFns } from "./FormNavio.vue?vue&type=template&id=52ff4634"
import script from "./FormNavio.vue?vue&type=script&lang=js"
export * from "./FormNavio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports